<template>
  <div class="hello">
    <div class="msg1">
      <div class="banner">
        <h2>杰宜斯云，用心为您服务</h2>
        <p>
          提供杰宜斯金融软件终端产品帮助中心、多账户金融终端、交易分析评估等增值服务，
          <br />
          实现期货投资业务的深度支持，致力于为客户打造一个开放、贴身的金融服务云环境。
        </p>
        <div class="shengming">
          声明：“杰宜斯云”服务平台系武汉杰宜斯信息科技有限公司（以下称：我司）为客户提供的增值服务平台，该平台主要作用有数据分析及展示，我司不会对客户数据进行抓取、存储，不会使用客户数据进行盈利性商业活动。我司所有开放行为均会在客户认可、自主的前提下进行，随时接受客户监督。
        </div>
        <div style="display: flex;margin-bottom: 30px;">
          <div style="margin-right: 50px;">
            <span style="width: 130px;font-size: 12px;white-space: nowrap;"
              >扫描进入云服务小程序</span
            >
            <li>
              <img
                v-show="!guide"
                src="../../assets/images/xiaochengxu.png"
                alt=""
              />
            </li>
          </div>
          <div>
            <span style="font-size: 12px;">技术认证</span>
            <img
              style="width: 123px;height: 54px;border: 0;"
              src="../../assets/images/huawei.png"
              alt=""
            />
          </div>
        </div>
        <!-- 注册和登录按钮 -->
        <div class="show_login" v-if="token">
          <span @click="r_btn">立即注册</span>
          <span @click="l_btn">登录</span>
        </div>
      </div>
    </div>

    <div class="banner_1">
      <p class="e_title">Our advantage</p>
      <div class="title_box">
        <img src="../../assets/images/rt.png" alt="" />
        <h3>我们的优势</h3>
        <img src="../../assets/images/lt.png" alt="" />
      </div>
      <img class="xhx" src="../../assets/images/xhx.png" alt="" />

      <div class="f_box">
        <div>
          <li
            @click="li_1"
            :style="{
              transform: transform1,
              width: width1,
              marginLeft: margin1,
              position: 'relative',
              zIndex: zIndex1,
              opacity: opacity1,
              transition: '0.1s'
            }"
          >
            <img
              style="width:245px;height: 184px;margin-top: 46px;"
              src="../../assets/images/bg/page2.png"
              alt=""
            />
            <h6>交易分析工具，归因分析更简单</h6>
            <p>
              杰宜斯云服务不仅支持内部账户的评估分析，<br />
              同时也支持结算单导入进行账户交易的归因分析，一键生成<br />
              评估分析报告，并且可以存储在云端，可随时通过微信、<br />
              PC端查看与分享。
            </p>
            <button @click="goRouter('/user/ctp_user/list')">立即体验</button>
          </li>
        </div>
        <div>
          <li
            @click="li_2"
            :style="{
              transform: transform2,
              width: width2,
              marginLeft: margin2,
              position: 'relative',
              zIndex: zIndex2,
              opacity: opacity2,
              transition: '0.1s'
            }"
          >
            <img
              style="width: 290px;height: 162px;margin-top: 49px;"
              src="../../assets/images/bg/page1.png"
              alt=""
            />
            <h6>多账户交易终端，助力交易能力升级</h6>
            <p>
              杰宜斯云服务与杰宜斯期货交易系统相结合，<br />
              支持多个账户的集合交易，提升期货交易效率，<br />
              让您的交易如虎添翼。
            </p>
            <button @click="goRouter('/index/download2')">立即体验</button>
          </li>
        </div>
        <div>
          <li
            @click="li_3"
            :style="{
              transform: transform3,
              width: width3,
              marginLeft: margin3,
              position: 'relative',
              zIndex: zIndex3,
              opacity: opacity3,
              transition: '0.1s'
            }"
          >
            <img
              style="width: 237px;height: 182px;margin-top: 36px;"
              src="../../assets/images/bg/page3.png"
              alt=""
            />
            <h6>微信云服务，账户动态随手掌握</h6>
            <p>
              通过杰宜斯云服务的微信公众号，<br />
              帮助您随时随地查看账户交易评估报告，及时掌握每个账户的动态，<br />
              同时支持在PC端导出评估报告并分享。
            </p>
            <button   @click="getIOCode">立即体验</button>
          </li>
        </div>
      </div>
    </div>

    <!-- <div class="banner_1" style="padding-top: 0;">
      <p class="e_title">Contact Information</p>
      <div class="title_box">
        <img src="../../assets/images/rt.png" alt="" />
        <h3 style="margin: 0 25px;">联系方式</h3>
        <img src="../../assets/images/lt.png" alt="" />
      </div>
      <img class="xhx" src="../../assets/images/xhx.png" alt="" />

      <div class="fb_box" style="height: 100px;">
        <div>
          <span>业务咨询:</span>
          <p>13007161998</p>
        </div>
        <div>
          <span>客户服务1:</span>
          <p>15972005680</p>
        </div>
        <div>
          <span>客户服务2:</span>
          <p>15972168177</p>
        </div>
      </div>
    </div> -->
    <div class="banner_1" style="padding-top:0">
      <p class="e_title">Contact  us  </p>
      <div class="title_box" style="width:153px">
        <img src="../../assets/images/rt.png" alt="" />
        <h3>联系我们</h3>
        <img src="../../assets/images/lt.png" alt="" />
      </div>
      <img class="xhx" src="../../assets/images/xhx.png" alt="" />

      <div class="banner_card">
        <div class="card_box">
          <div class="card_L">
            <img src="./img/phone.png" alt="">
          </div>
          <div class="card_R">
            <p class="card_title">咨询热线</p>
            <p class="card_phone">4006611558</p>
          </div>
        </div>
        <div class="card_box" style="margin-left:60px">
          <div class="card_L">
            <img src="./img/address.png" alt="">
          </div>
          <div class="card_R">
            <p class="card_title" style="margin-bottom:10px">公司地址</p>
            <p class="card_address" style="margin-bottom:2px">武汉：湖北省武汉市武昌区海山金谷写字楼1501-1502室</p>
            <p class="card_address">上海：上海市浦东新区向城路58号东方国际科技大厦1105室</p>
          </div>
        </div>
      </div>

      
    </div>


    <div v-if="guide" class="shadow">
      <div class="yuan">
        <span>账户列表</span>
        <span>模拟账户申请</span>
      </div>
      <p class="text">这些功能可以直接在手机上进行操作</p>
      <img class="jiantou" src="../../assets/images/bg/jiantou.png" alt="" />
      <div class="block">
        微信扫描这里进入杰宜斯云小程序
        <span class="bottom"></span>
      </div>
      <div class="code">
        <div class="box">
          <img src="../../assets/images/xiaochengxu.png" alt="" />
        </div>
        <div class="iknowBox" @click="nextStep">
          <!-- 我知道了 -->
          下一步
        </div>
      </div>
    </div>

    <div v-if="fenzhuShow" class="shadow">
      <div class="yuan yunfuwu">
        <span>云服务</span>
      </div>
      <div class="yunfuwu-list">
        <div>账户列表</div>
        <div style="color: #4071FE;">分组管理</div>
        <div>外部数据导入分析</div>
      </div>
      <div class="grouping-modul">
        <img
          class="jiantou"
          style="width: 160px;"
          src="../../assets/images/bg/jiantouxia.png"
          alt=""
        />
        <div class="grouping">
          新增“分组管理”功能，查看更便捷
          <div class="grouping-sanjiao"></div>
          <div class="grouping-zhidao">
            <div class="iknowBox" @click="guideClick">
              我知道了
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="el-fade-in-linear">
      <div
        class="wxCode"
        v-show="code_show1"
        @click.stop.prevent="code_show1 = false"
      >
        <div
          class="wxBox"
          style="background-color: #fff;width: 400px;padding-top: 1px;text-align: center;"
          @click.stop.prevent="stop"
        >
          <h2 style="color: #000;margin-top: 20px;">微信公众号</h2>
          <!-- <div style="margin-top:20px">
            <el-link type="primary" href="https://webtrader.jeesit.com/#/login"
              >https://webtrader.jeesit.com/#/login</el-link
            >
          </div> -->
          <!-- <div class="code"><canvas id="IOCode" /></div> -->
          <div class="code"><img src="./img/weixin.png" alt="" style="width:290px;height:300px"></div>
          <!-- <el-button style="margin-top:20px" type="primary" @click="fz()"
            >复制</el-button
          >
          <h3 style="margin-top: 30px;font-size: 14px;">
            使用手机浏览器打开以上网址
          </h3>
          <h3 style="font-size: 14px;">即可登录操作</h3> -->
          <h3 style="margin-top: 30px;font-size: 18px;">
            请使用微信扫一扫
          </h3>
          <h3 style="font-size: 18px;">扫描进入微信公众号</h3>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import register from "../register/index";
import "./style.css";
import QRCode from "qrcode";
export default {
  components: { register },
  name: "msg",
  data() {
    return {
      guide: false, //引导
      fenzhuShow: false, //引导
      close: false, //遮罩层是否要关闭按钮
      centerDialogVisible: false, //显示遮罩层
      width_: "1200px", //响应式宽
      screenWidth: document.body.clientWidth, //获取浏览器可视宽
      token: true, //本地存储
      type: "",
      transform1: "scale(1,1)",
      transform2: "scale(1.27,1.27)",
      transform3: "scale(1,1)",
      width1: "380px",
      width2: "425px",
      width3: "380px",
      margin1: 0,
      margin2: "-23px",
      margin3: 0,
      zIndex1: 0,
      zIndex2: 10,
      zIndex3: 0,
      opacity1: "0.6",
      opacity2: "1",
      opacity3: "0.6",
      code_show1:false,
      IOCodeMsg:'',
    };
  },
  mounted() {
    let show = localStorage.getItem("guideClick");
    console.log(show, 4789);
    if (!show) {
      this.guide = true;
      if (this.guide) {
        var mo = function(e) {
          e.preventDefault();
        };
        document.body.style.overflow = "hidden";
        document.addEventListener("touchmove", mo, false); //禁止页面滑动
      } else {
        this.move();
      }
    } else {
      this.guide = false;
    }

    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };

    if (localStorage.getItem("token")) {
      this.token = false;
    } else {
      this.token = true;
    }
  },
  methods: {
    move() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    r_btn() {
      //注册按钮
      // this.centerDialogVisible = true;
      this.type = "register";
      this.$router.push("login?type=register");
    },
    l_btn() {
      // this.centerDialogVisible = true;
      this.type = "login";
      this.$router.push("login?type=login");
    },
    li_1() {
      this.transform1 = "scale(1.27,1.27)";
      this.width1 = "425px";
      this.margin1 = "-23px";
      this.zIndex1 = 10;
      this.opacity1 = "1";

      this.transform2 = "scale(1,1)";
      this.width2 = "380px";
      this.margin2 = 0;
      this.zIndex2 = 0;
      this.opacity2 = "0.6";

      this.transform3 = "scale(1,1)";
      this.width3 = "380px";
      this.margin3 = 0;
      this.zIndex3 = 0;
      this.opacity3 = "0.6";
    },
    li_2() {
      this.transform1 = "scale(1,1)";
      this.width1 = "380px";
      this.margin1 = 0;
      this.zIndex1 = 0;
      this.opacity1 = "0.6";

      this.transform2 = "scale(1.27,1.27)";
      this.width2 = "425px";
      this.margin2 = "-23px";
      this.zIndex2 = 10;
      this.opacity2 = "1";

      this.transform3 = "scale(1,1)";
      this.width3 = "380px";
      this.margin3 = 0;
      this.zIndex3 = 0;
      this.opacity3 = "0.6";
    },
    li_3() {
      this.transform1 = "scale(1,1)";
      this.width1 = "380px";
      this.margin1 = 0;
      this.zIndex1 = 0;
      this.opacity1 = "0.6";

      this.transform2 = "scale(1,1)";
      this.width2 = "380px";
      this.margin2 = 0;
      this.zIndex2 = 0;
      this.opacity2 = "0.6";

      this.transform3 = "scale(1.27,1.27)";
      this.width3 = "425px";
      this.margin3 = "-23px";
      this.zIndex3 = 10;
      this.opacity3 = "1";
    },
    nextStep() {
      this.guide = false;
      this.fenzhuShow = true;
    },
    guideClick() {
      this.fenzhuShow = false;
      localStorage.setItem("guideClick", 1);
      this.move();
    },
    goRouter(e){
      window.scrollTo(0, 0); 
      this.$router.push(e)
    },
    getIOCode() {
      this.code_show1 = true
      // this.IOCodeMsg = "https://open.weixin.qq.com/qr/code?username=JeesYun";
    },
    
  },
  watch: {
    // guide(e) {
    //   if (e) {
    //     var mo = function(e) {
    //       e.preventDefault();
    //     };
    //     document.body.style.overflow = 'hidden';
    //     document.addEventListener('touchmove', mo, false); //禁止页面滑动
    //   } else {
    //     this.move();
    //   }
    // },
    // IOCodeMsg(val) {
    //   var msg = document.getElementById("IOCode");
    //   // 将获取到的数据（val）画到msg（canvas）上
    //   QRCode.toCanvas(msg, val, function(error) {
    //     // console.log(error);
    //   });
    // }
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/msg/index.vue